import _ from "lodash-es";

export function parseDate(date) {
    return date ? (new Date(date)).toLocaleString() : null
}

export const progressPt = value => {
    if (value < 0 || value > 1) {
        throw new Error("Value must be between 0 and 1");
    }

    let color;
    const percentage = value * 100;

    if (percentage < 35) {
        color = '#cc0000'; // red
    } else if (percentage < 75) {
        color = '#ffa500'; // orange
    } else {
        color = '#00aa00'; // green
    }

    return {
        value: {
            style: {
                background: color,
            }
        }
    }
}
export const progressTooltip = (name, value) => {
    const contents = {
        digitalization: 'indicates how many of your activities are measurable, i.e. can be found in the data.',
        adherence_ratio: 'indicates which ratio of process instances and their activities found in the data conform with the defined business rule(s).',
        coverage: 'indicates how much of your process is under control, i.e. defined business rules.'
    }
    return `${_.startCase(name)}: ${_.round(value * 100)}% - ${contents[name]}`
}